/**
 * Created by synerzip on 28/01/16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import PureComponent from '../utils/PureComponent';
import { Table } from 'fixed-data-table-2';
import debounce from 'debounce';

const assign = Object.assign;

class ResponsiveFixedDataTable2 extends PureComponent {
    static propTypes = {
        containerStyle: PropTypes.object,
        refreshRate: PropTypes.number
    }

    static defaultProps = {
        containerStyle: {},
        refreshRate: 250
    }

    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = {
            gridWidth: 1,
            gridHeight: 1
        };
        this._setDimensionsOnState = debounce(this._setDimensionsOnState.bind(this), this.props.refreshRate);
    }

    componentDidMount() {
        this._isMounted = true;
        this._setDimensionsOnState();
        this._attachResizeEvent();
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('resize', this._setDimensionsOnState);
    }

    _attachResizeEvent() {
        var win = window;
        if (win.addEventListener) {
            win.addEventListener('resize', this._setDimensionsOnState, false);
        } else if (win.attachEvent) {
            win.attachEvent('resize', this._setDimensionsOnState);
        } else {
            win.onresize = this._setDimensionsOnState;
        }
    }

    _setDimensionsOnState() {
        if (!this._isMounted) return;
        try {
            var tableWrapperNode = ReactDOM.findDOMNode(this);
            if (tableWrapperNode) {
                this.setState({
                    gridWidth: tableWrapperNode.offsetWidth,
                    gridHeight: tableWrapperNode.offsetHeight
                });
            }
        } catch (e) {
            // Component may be unmounting
        }
    }

    _getStyle() {
        return assign({}, this.props.containerStyle, {
            width: '100%',
            height: '100%'
        });
    }

    render() {
        return (
            <div style={this._getStyle()}>
                <Table {...this.props} ref="table" width={this.state.gridWidth} height={this.state.gridHeight} />
            </div>
        );
    }
}

export default ResponsiveFixedDataTable2;
